import React from 'react';
import 'twin.macro';
import { DeleteAccount } from '@teetsh/app/src/containers/UserSettings/Compte/DeleteAccount';
import { Features } from '@teetsh/app/src/containers/UserSettings/Compte/Features';
import { GeneralInfos } from '@teetsh/app/src/containers/UserSettings/Compte/GeneralInfos';
import { useUserAccount } from '@teetsh/app/src/queries/user/account/useUserAccount';
import SpinnerComponent from '@teetsh/app/src/components/Spinner/ScreenSpinner';
import allTz from '@teetsh/app/src/containers/timezones';

export const isValidAndRequiredTimezone = (value, t) => {
  if (!value) {
    return t('userSettings:notifications.requiredTimezone');
  }
  return allTz.includes(value)
    ? undefined
    : t('userSettings:notifications.invalidTimezone');
};

export function Compte() {
  const { isLoading, data: userAccount } = useUserAccount();

  if (isLoading || !userAccount) {
    return <SpinnerComponent />;
  }

  return (
    <>
      <GeneralInfos userAccount={userAccount} />
      <Features />
      <DeleteAccount />
    </>
  );
}
